import { contentfulImageUrl } from '@telialt/utils/src/Contentful/contentfulImageUrl';

import { BlogSectionType } from '../../../models/Content';

export const transformSectionImage = (content: BlogSectionType) => {
    return {
        url: contentfulImageUrl(content.fields.images?.[0]?.fields?.file?.url),
        alt: content.fields.images?.[0]?.fields?.description,
    };
};
